module.exports = __webpack_public_path__ + "img/Grejanje_DISTANT_HEATING.26b1470a.svg";